module.exports = __webpack_public_path__ + "static/media/burberry-my-burberry-black-big.c9837230.png";